import AnimationFactory from "../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import ScreenNavigator from "../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator";
import AbstractInstaller from "../application/AbstractInstaller";
import NavigateCommand from "./NavigateCommand";
import NavigateEvent from "./NavigateEvent";

export default class ScreenNavigationInstaller extends AbstractInstaller {


    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        commands.add(NavigateEvent.OPEN_SCREEN_REQUEST, NavigateCommand);
        commands.add(NavigateEvent.GOTO_SCREEN_REQUEST, NavigateCommand);
        commands.add(NavigateEvent.CLOSE_SCREEN_REQUEST, NavigateCommand);
        commands.add(NavigateEvent.POP_UP_REQUEST, NavigateCommand);
        commands.add(NavigateEvent.CLOSE_POP_UP_REQUEST, NavigateCommand);
        
        const stage = this._getValue("stage");
        const dispatcher = this._getValue("dispatcher");
        const animationFactory = new AnimationFactory();
        var screenNavigator = new ScreenNavigator(stage.getChildAt(0), dispatcher, animationFactory);
        screenNavigator.setScreenDimensions(stage.canvas.width, stage.canvas.height);
        injector.mapValue("screenNavigator", screenNavigator);

        //startup tasks:
        //None
    }
}